import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "text-lg font-semibold" }
const _hoisted_4 = { class: "mt-2 text-gray-600" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "custom-search" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-9" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_14 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_15 = { class: "d-sm-flex align-items-center" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_18 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_19 = {
  key: 1,
  class: "text-info"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_28 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_29 = { class: "d-sm-flex align-items-center" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_32 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_33 = {
  key: 1,
  class: "text-info"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { class: "justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 4 }
const _hoisted_41 = {
  class: "modal fade",
  id: "modal_detail_suivi",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_42 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_43 = { class: "modal-content p-15 p-md-40" }
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = {
  class: "modal fade",
  id: "modal_detail_colis",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_46 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_47 = { class: "modal-content p-15 p-md-40" }
const _hoisted_48 = { class: "modal-body" }
const _hoisted_49 = {
  class: "modal fade",
  id: "modal_update",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_50 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_51 = { class: "modal-content p-15 p-md-40" }
const _hoisted_52 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_HistoryColis = _resolveComponent("HistoryColis")!
  const _component_DetailsColis = _resolveComponent("DetailsColis")!
  const _component_UpdateParcel = _resolveComponent("UpdateParcel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.sendNote.note_ref), 1),
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.sendNote.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_5, _toDisplayString(_ctx.getDate(_ctx.sendNote.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
          _cache[11] || (_cache[11] = _createTextVNode(" | ENVOIE : ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.sendNote.sending_zone_name) + " " + _toDisplayString(_ctx.sendNote.sending_agency_name), 1),
          _cache[12] || (_cache[12] = _createTextVNode(" | RECEPTION : ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.sendNote.reception_zone_name) + " " + _toDisplayString(_ctx.sendNote.reception_agency_name), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h6", null, "Scan code suivi")
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchColis && _ctx.searchColis(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", null, "Code Suivi :", -1)),
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Code Suivi",
                    type: "text",
                    id: "scanFocus",
                    ref: "scaninput",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.codeColis) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.codeColis]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[15] || (_cache[15] = _createElementVNode("button", {
                  style: {"margin-right":"12px"},
                  class: "btn btn-success me-3 mb-3 mt-3",
                  type: "submit"
                }, [
                  _createElementVNode("i", { class: "ph ph-scan" })
                ], -1)),
                _createElementVNode("button", {
                  class: "btn btn-primary me-3 mb-3 mt-3",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshAll && _ctx.refreshAll(...args)))
                }, _cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "ph ph-arrows-clockwise" }, null, -1)
                ]))
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-12" }, [
                _createElementVNode("hr")
              ], -1))
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "border-b p-4" }, [
        _createElementVNode("h3", { class: "text-lg font-semibold" }, "Liste des nouveaux colis")
      ], -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNewColis && _ctx.addNewColis(...args)))
          }, _cache[18] || (_cache[18] = [
            _createTextVNode(" Ajouter ", -1),
            _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.users1.searchTerm) = $event)),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getRows1())),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 544), [
            [_vModelText, _ctx.users1.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows1,
          "row-key": 'id',
          "select-options": {
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Demandes Sélectionées',
        },
          onSelectedRowsChange: _ctx.selectionChanged,
          onSelectAll: _ctx.onSelectAll
        }, {
          emptystate: _withCtx(() => _cache[19] || (_cache[19] = [
            _createElementVNode("div", { class: "text-center py-4 text-gray" }, " Aucune entrées correspondants trouvés ", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_18, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[20] || (_cache[20] = _createElementVNode("i", { class: "icon-repeat" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_19, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[21] || (_cache[21] = _createElementVNode("i", { class: "icon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_20, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second)
                  .code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'actions')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.showDetailSuivi(props.row)),
                          class: "transition d-inline-block position-relative border-0 rounded-circle ml-2"
                        }, _cache[22] || (_cache[22] = [
                          _createElementVNode("i", { class: "flaticon-clock" }, null, -1)
                        ]), 8, _hoisted_23),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.showDetails(props.row)),
                          class: "transition d-inline-block position-relative border-0 rounded-circle ml-2"
                        }, _cache[23] || (_cache[23] = [
                          _createElementVNode("i", { class: "flaticon-view" }, null, -1)
                        ]), 8, _hoisted_24)
                      ])
                    ]))
                  : (props.column.field === 'updated_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectedRowsChange", "onSelectAll"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users1,
          offset: 9,
          onPaginate: _ctx.getRows1
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "border-b p-4" }, [
        _createElementVNode("h3", { class: "text-lg font-semibold" }, "Liste des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          (
            _ctx.auth.can('ADD_RECEPTION') &&
            Object.keys(_ctx.sendNote).length != 0 &&
            _ctx.sendNote.note_saved != 1
          )
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removeNewColis && _ctx.removeNewColis(...args)))
              }, _cache[25] || (_cache[25] = [
                _createTextVNode(" Supprimer ", -1),
                _createElementVNode("i", { class: "flaticon-delete position-relative ms-5 fs-12" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getRows2())),
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.users2.searchTerm) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 544), [
            [_vModelText, _ctx.users2.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_vue_good_table, {
          "search-options": { enabled: true, externalQuery: _ctx.searchTerm2 },
          columns: _ctx.columns,
          "row-key": 'id',
          rows: _ctx.rows2,
          responsive: "",
          "select-options": {
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis sélectionées',
        },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => _cache[26] || (_cache[26] = [
            _createElementVNode("div", { class: "text-center py-4 text-gray" }, " Aucune entrées correspondants trouvés ", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_32, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[27] || (_cache[27] = _createElementVNode("i", { class: "icon-repeat" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_33, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[28] || (_cache[28] = _createElementVNode("i", { class: "icon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_34, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second)
                  .code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'updated_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                  : (props.column.field === 'actions')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.showDetailSuivi(props.row)),
                            class: "transition d-inline-block position-relative border-0 rounded-circle ml-2"
                          }, _cache[29] || (_cache[29] = [
                            _createElementVNode("i", { class: "flaticon-clock" }, null, -1)
                          ]), 8, _hoisted_38),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.showDetails(props.row)),
                            class: "transition d-inline-block position-relative border-0 rounded-circle ml-2"
                          }, _cache[30] || (_cache[30] = [
                            _createElementVNode("i", { class: "flaticon-view" }, null, -1)
                          ]), 8, _hoisted_39)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["search-options", "columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users2,
          offset: 9,
          onPaginate: _ctx.getRows2
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Historique Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_44, [
            (_ctx.colisId)
              ? (_openBlock(), _createBlock(_component_HistoryColis, {
                  key: 0,
                  colisId: _ctx.colisId,
                  isOpen: _ctx.isOpenModal,
                  status: _ctx.statuts
                }, null, 8, ["colisId", "isOpen", "status"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Détails Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_48, [
            (_ctx.coliDetails)
              ? (_openBlock(), _createBlock(_component_DetailsColis, {
                  key: 0,
                  coliDetails: _ctx.coliDetails,
                  isOpen: _ctx.isOpenModal
                }, null, 8, ["coliDetails", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modifier Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_52, [
            (_ctx.rowUpdate)
              ? (_openBlock(), _createBlock(_component_UpdateParcel, {
                  key: 0,
                  rowColis: _ctx.rowUpdate,
                  getRecords: _ctx.getRecords,
                  isOpenEdit: _ctx.isOpenEdit,
                  hideModal: _ctx.hideModal
                }, null, 8, ["rowColis", "getRecords", "isOpenEdit", "hideModal"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}